import { render, staticRenderFns } from "./ParcoursItem.vue?vue&type=template&id=77d2869b&scoped=true&"
import script from "./ParcoursItem.vue?vue&type=script&lang=js&"
export * from "./ParcoursItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d2869b",
  null
  
)

export default component.exports